import React, { useState, useEffect } from "react";
import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/Help";
import commonConstant from "../../constants/Common";
import configuration from "../../config";
import { toast } from "react-toastify";
import UND from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add Help
function Add({ history }) {
  const [fieldArr, setFieldArr] = useState([]);
  const [fields, setFields] = useState({});
  const [answer, setAnswer] = useState({});
  const [languages, setLanguages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);

  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];

  let baseColumns = [
    {
      id: 0,
      title: "User Type",
      name: "user_type",
      type: "Dropdown",
      options: commonConstant.user_type,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "HELP");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });

    Promise.all([
      configuration.getAPI({
        url: "common/list-order-no",
        params: { lang_code: "EN", collectionName: "helps" },
      }),
      configuration.getAPI({
        url: "help-category/list",
        params: { status: "active" },
      }),
      configuration.getAPI({
        url: "language/list",
        params: { status: "active" },
      }),
    ])
      .then(([orderRes, catRes, langRes]) => {
        let finalColumns = [...baseColumns];

        // Order No
        if (orderRes.status === 200) {
          const orderNoArr = orderRes.payload.map((singleRec) => ({
            title: singleRec.title,
            value: singleRec.order_no,
            id: singleRec.order_no,
          }));
          finalColumns.push({
            id: 1,
            title: "Order No",
            name: "order_no",
            type: "Dropdown",
            options: orderNoArr,
          });
        }

        // Help Category
        if (catRes.status === 200) {
          const catArr = catRes.payload.map((singleRec) => ({
            title: `${singleRec.title["EN"]} - ${singleRec.user_type}`,
            value: singleRec.help_category_id,
            id: singleRec.help_category_id,
          }));
          finalColumns.push({
            id: 4,
            title: "Help Category",
            name: "help_category_id",
            type: "Dropdown",
            options: catArr,
          });
        }

        // Languages -> Question & Answer
        if (langRes.status === 200) {
          setLanguages(langRes.payload);
          const languages = langRes.payload;
          const que_arr = languages.map((lang, index) => ({
            id: `q_${index}`,
            title: `Question[${lang.title}]`,
            name: `question_${lang.code}`,
            type: "TextInput",
          }));
          const ans_arr = languages.map((lang, index) => ({
            id: `a_${index}`,
            title: `Answer[${lang.title}]`,
            name: `answer_${lang.code}`,
            type: "Editor",
            is_full_screen: true,
          }));
          finalColumns = [...finalColumns, ...que_arr, ...ans_arr];
        }

        setFieldArr(finalColumns);
      })
      .catch((error) => toast.error(error.message));
  }, []);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.user_type) {
      error["user_type"] = "Please select user type";
      flag = false;
    }
    if (!fields.order_no) {
      error["order_no"] = "Please enter order no";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    if (!fields.help_category_id) {
      error["help_category_id"] = "Please select help category";
      flag = false;
    }
    UND.each(languages, (lang, ind) => {
      if (!fields["question_" + lang.code]) {
        error["question_" + lang.code] =
          "Please enter question in " + lang.title;
        flag = false;
      }
      // if (!fields['answer_' + lang.code]) {
      //   error['answer_' + lang.code] = "Please enter answer in " + lang.title
      //   flag = false
      // }

      // if (!fields['link_' + lang.code]) {
      //   error['link_' + lang.code] = "Please enter link in " + lang.title
      //   flag = false
      // }
    });
    setErrors({ ...error });
    return flag;
  }

  // function handleChange(field, e) {
  //   setFields({ ...fields, [field]: e.target.value })
  // }

  function handleChange(field, e) {
    if (field.search("answer") >= 0) {
      setAnswer({ ...answer, [field]: e.target.getContent() });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      const fullObj = {
        ...answer,
        ...fields,
      };
      configuration
        .postAPI({ url: "help/create", params: fullObj })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/help");
            toast.success("Record added successfully");
          } else if (data.status === 404) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addHelp} />
      <AddEditSection
        title="Add Help"
        path="/help"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
